import { gql } from "graphql-tag";

import { getProductCatalogueV2 } from "~/slices/ProductCatalogueV2/fragment";
import { getCallToAction } from "~/slices/CallToAction/fragment";
import { getTopCategory } from "~/slices/TopCategory/fragment";
import { getSeoFields, getMetaFields } from "~/mixins/seoMixin";
import { documentLink } from "~/app/prismic/prismic-fragments";

const PAGE_TYPE = "Cart";

const CART_PAGE_QUERY = gql`
  query cart(
    $uid: String!
    $isCartEmpty: Boolean!
    $lazy: Boolean!
    $lang: String = "en-in"
  ) {
    ${PAGE_TYPE}: cart(uid: $uid, lang: $lang) {
      title
      description
      checkout_text
      checkout_background_color
      checkout_color
      checkout_font
      show_donation
      show_offer
      offer_tags
      checkout_sticky_text
      ...${PAGE_TYPE}SEOFields
      ...${PAGE_TYPE}MetaFields
      payment_icon_document {
        ...documentLink
      }
      slices: body {
        ...${PAGE_TYPE}_call_to_action @include(if: $isCartEmpty)
        ...${PAGE_TYPE}_top_category @include(if: $isCartEmpty)
        ...${PAGE_TYPE}_product_catalogue_v2
      }
    }
  }
  ${getProductCatalogueV2(PAGE_TYPE)}
  ${getCallToAction(PAGE_TYPE)}
  ${getTopCategory(PAGE_TYPE)}
  ${getSeoFields(PAGE_TYPE)}
  ${getMetaFields(PAGE_TYPE)}
  ${documentLink}
`;

export { PAGE_TYPE, CART_PAGE_QUERY };
